import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {
  ServiceChangeRequest,
  ServiceChangeRequestApprovalInput,
  ServiceChangeRequestInput
} from './service-change-request.model';

export const loadServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Load ServiceChangeRequests',
  props<{ serviceChangeRequests: ServiceChangeRequest[] }>()
);

export const addServiceChangeRequest = createAction(
  '[ServiceChangeRequest/API] Add ServiceChangeRequest',
  props<{ serviceChangeRequest: ServiceChangeRequest }>()
);

export const upsertServiceChangeRequest = createAction(
  '[ServiceChangeRequest/API] Upsert ServiceChangeRequest',
  props<{ serviceChangeRequest: ServiceChangeRequest }>()
);

export const addServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Add ServiceChangeRequests',
  props<{ serviceChangeRequests: ServiceChangeRequest[] }>()
);

export const upsertServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Upsert ServiceChangeRequests',
  props<{ serviceChangeRequests: ServiceChangeRequest[] }>()
);

export const updateServiceChangeRequest = createAction(
  '[ServiceChangeRequest/API] Update ServiceChangeRequest',
  props<{ serviceChangeRequest: Update<ServiceChangeRequest> }>()
);

export const updateServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Update ServiceChangeRequests',
  props<{ serviceChangeRequests: Update<ServiceChangeRequest>[] }>()
);

export const deleteServiceChangeRequest = createAction(
  '[ServiceChangeRequest/API] Delete ServiceChangeRequest',
  props<{ id: string }>()
);

export const deleteServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Delete ServiceChangeRequests',
  props<{ ids: string[] }>()
);

export const clearServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Clear ServiceChangeRequests'
);


// CUSTOM
export const createServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] Create ServiceChangeRequests',
  props<{ input: ServiceChangeRequestInput }>()
);


export const getServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] get all ServiceChangeRequests',
  props<{ serviceUniqueId: string }>()
);


export const getPopsmServiceChangeRequests = createAction(
  '[ServiceChangeRequest/API] get popsm all ServiceChangeRequests'
);


export const popsmServiceChangeRequestApproval = createAction(
  '[ServiceChangeRequest/API] popsm ServiceChangeRequests approval',
  props<{ input: ServiceChangeRequestApprovalInput, id: string }>()
);

export const reviewServiceChangesRequestMutation = createAction(
  '[ServiceChangeRequest/API] review ServiceChangeRequests',
  props<{ input: ServiceChangeRequestInput, }>()

)
